import React from 'react';
import PaymentResultModal from "./paymentResultModal";

const SuccessContent = () => {
    return (<PaymentResultModal success={true} />)
};

export default SuccessContent
